module.exports = __webpack_public_path__ + "public/img/all.d0f65993.png";